import React, { useState } from 'react';
import { IUser } from '../../Interfaces/IUser';
import { IUserGroup } from '../../Interfaces/IUserGroup';
import { useGetLegalRequirementsExpired } from '../../hooks/reactQuerys/LegalRequirementQueries';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { Warning } from '@mui/icons-material';
import { AccordionLegend } from './AccordionLegend';
import { RequirementColumn } from './RequirementColumn';

interface IProps {
  userArray: IUser[];
  userGroupArray: IUserGroup[];
}

const ROWS_PER_PAGE = 10;

// Wie bei den zu prüfenden Maßnahmen: Notar (20) und Mitarbeiter/Gruppe (15) werden getrennt
// abgefragt und paginiert, damit beide Spalten vollständig befüllt sind (#1056).
const STATE_NOTARY = 20;
const STATE_EMPLOYEE = 15;

export const CardRequirementsExpired: React.FC<IProps> = ({
  userArray,
  userGroupArray,
}) => {
  const [notaryPage, setNotaryPage] = useState(1);
  const [employeePage, setEmployeePage] = useState(1);

  const notary = useGetLegalRequirementsExpired(
    `order_by=Created_at&page=${notaryPage}&rowsPerPage=${ROWS_PER_PAGE}&idLegalRequirementState=${STATE_NOTARY}`
  );
  const employee = useGetLegalRequirementsExpired(
    `order_by=Created_at&page=${employeePage}&rowsPerPage=${ROWS_PER_PAGE}&idLegalRequirementState=${STATE_EMPLOYEE}`
  );

  return (
    <Card variant='outlined' sx={{ backgroundColor: '#ffbebeff' }}>
      <CardContent>
        <Grid container alignItems='center'>
          <Grid item sm={8} sx={{ display: 'flex', alignItems: 'center' }}>
            <Warning sx={{ m: 2, mb: 1, fontSize: 30 }} />
            <Typography>Überfällige Maßnahmen im Notarbüro</Typography>
          </Grid>
          <Grid item sm={4}>
            <AccordionLegend />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item sm={6}>
            <RequirementColumn
              title='Notar'
              isNotary={true}
              userArray={userArray}
              userGroupArray={userGroupArray}
              legReqs={notary.legReqs}
              isLoadingLegReqs={notary.isLoadingLegReqs}
              page={notaryPage}
              setPage={setNotaryPage}
              rowsPerPage={ROWS_PER_PAGE}
            />
          </Grid>
          <Grid item sm={6}>
            <RequirementColumn
              title='Mitarbeiter'
              isNotary={false}
              userArray={userArray}
              userGroupArray={userGroupArray}
              legReqs={employee.legReqs}
              isLoadingLegReqs={employee.isLoadingLegReqs}
              page={employeePage}
              setPage={setEmployeePage}
              rowsPerPage={ROWS_PER_PAGE}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
